import React from 'react'
import { flightModeStyle } from './style'

export const DateControl = ({ onChange, value, minDate, log }) => {
  const today = minDate ?? (new Date).toISOString().split('T')[0]
  const handleChange = (val) => {
    if(log)
      console.log('DateControl', val, today)

    if(onChange)
      onChange(val)
  }

  return (
    <input style={flightModeStyle.input} type="date" min={today} onChange={(e) => handleChange(e.target.value)} value={value} />
  )
}